import React, { useState, useEffect } from 'react'

// import AdapterDateFns from '@mui/lab/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
// import TimePicker from '@mui/lab/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from '@mui/material';

import heLocale from 'date-fns/locale/he';
import MyDateTime from '../../../../MySections/TimeSections/MyDateTime';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';

// import Login from '../Login/Login';
// import useToken from '../Login/useToken';


const OpeningHours = (props) => {
    const [hrs, setSrh] = useState(props.theHours);

    useEffect(() => {
        setSrh(props.theHours);
    }, [props.theHours]);





    const updateHours = (index, val, OpenOrClose) => {

        let tempOpenHours = hrs;
        (OpenOrClose === "Open") ? tempOpenHours[index].Open = val : tempOpenHours[index].Close = val;
        props.SetTheHours(tempOpenHours);

    }


    return (
         <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={heLocale}>
            <table className={"tabTable tableBordSpace"}>
                <tbody>
                    {
                        hrs?.map((item, index) => {
                            return (
                                <tr key={index} style={{ marginTop: "10px" }}>
                                    <td style={{ width: "20%" }} className={"centerText"}>{MyDateTime.getDayOfWeekToHeb(item.Day)}</td>
                                    <td>
                                        <table className={"tblOpHours"}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <TimePicker
                                                            ampm={false}
                                                            label="פתיחה"
                                                            value={new Date(item.Open)}
                                                            onChange={(e) => updateHours(index, e, "Open")}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            className={"tmPick"}
                                                        />
                                                    </td>
                                                    <td>
                                                        <TimePicker
                                                            ampm={false}
                                                            label="סגירה"
                                                            value={new Date(item.Close)}
                                                            onChange={(e) => updateHours(index, e, "Close")}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            className={"tmPick"}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </td>

                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>

        </LocalizationProvider>
    )
}


export default OpeningHours;
